module.exports = __webpack_public_path__ + "media/images/landing_pages/hot_travel-328dd510593de186da30804f8808123e.svg";